__turbopack_context__.v({
  "loader": "Mn_Sua_loader",
});
